import React from "react"
import { OrgRouteComponentProps } from "../../RouteProps"
import { WorkerList } from "../../../Components/Views/Dashboard/Sections/Worker/WorkerList"
import { defaultWorkerSort } from "../../../Components/Views/Dashboard/Sections/Worker/Common/constants"
import { routePaths } from "../.."
import { useDecodeFilterAndSort } from "../../../Hooks/useDecodeFilterAndSort"
import { OrgAuthCheck } from "../../../Components/Common/AuthCheck/OrgAuthCheck"

export function WorkerListRoute({
    match,
    location
}: OrgRouteComponentProps<{}>) {
    const { sort } = useDecodeFilterAndSort(
        location.search,
        defaultWorkerSort,
        routePaths.orgWorkerList(match.params.orgUsername)
    )

    return (
        <OrgAuthCheck
            orgUsername={match.params.orgUsername}
            scope="worker:view"
        >
            <WorkerList
                orgUsername={match.params.orgUsername}
                showAddModal={false}
                sort={sort}
            />
        </OrgAuthCheck>
    )
}
